export const Region  = {
    NA : 'NA', 
    EU: 'EU', 
    EUO: 'EUO',
    APAC: 'APAC',
    CHINA: 'CHINA'
}

export const EMEAEUREGIONS : string[] = [
    Region.EU,
    Region.EUO
]

export enum ChannelSourceMapEnum  {
    EDI = 2, 
    Portal = 3, 
    PortalCSV = 4,
    CXML = 6, 
    SelfBilling = 15
}

export enum ChannelValidationStatus {
    New = 1,
    WorkInprogress = 2, 
    Approved = 3,
    Rejected = 4,
    Deleted = 5
}